import React, { useState } from "react";
import "./rechargemodal.css";

import { DateFormatter } from "../../../helper/Formatter";
import { getBills } from "../../../API/billApi";
import { createCheckoutBillSessionService } from "../../../API/payment";

export default function RechargeModal({setShowModal}) {
  const loginUserId = localStorage.getItem("LoginUserId");
  const loginUserType = localStorage.getItem("LoginUserType");
  const [formData, setFormData] = useState({
    // memberName: "Test 1",
    // memberNumber: "DRL100",
    creditPoint: "",
    remarks: "",
  });
    const [loader, setIsLoader] = useState(false);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

    const getAllBill = async (payload) => {
      return getBills(payload);
    };

   const handleSubmit = async () => {
    // if (!formData.creditPoint) {
    //   alert("Credit Point is required!");
    //   return;
    // }

    let billPayload =  {
      "customerid": loginUserId,                                             // MemberLoginId
      "onModel": loginUserType,
      "billdate": DateFormatter(new Date()),                                // current date
      "amount": 1,                                                        // how much do you want ?
      "totalamount": Number(formData?.creditPoint),     // how much do you want ?
      "taxes": [],                        // no need
      "balance": Number(formData?.creditPoint),         // how much do you want ?
      "paidamount": 0,
      "type": "Wallet",
      "property": {
          "remark": formData?.remarks,
          "sendmail": "yes"
      },
      "items": [
          {
              "item": {
                  "_id": "60a2236e48c98c3638e8b2ac",
                  "sale": {
                      "taxes": [],
                      "rate": 1
                  }
              },
              "itemnumber": "Refund",
              "sale": {
                  "taxes": [],
                  "rate": 1
              },
              "quantity": Number(formData?.creditPoint),
              "cost": 1,
              "totalcost": Number(formData?.creditPoint)
            }
          ]
        }


    if (loginUserId) {
      // setIsLoader(true)
      try {
        let res = await getAllBill(billPayload);
        // console.log('res::: ', res);
        let billId = res?.data?._id;
        let postData = {
          charges : Number(res?.data?.totalamount) ,
          memberid: loginUserId,
          billid:billId || res?.data?._id,
          paymentmode:"StripeAPI",
          // bookingid:""
          // seviceFee : userinfo?.,
          // paymentmode,
        };

        // console.log('postData::: ', postData);

        // return
        setIsLoader(true)
        const { data } = await createCheckoutBillSessionService(postData);

        window.open(data.url, '_blank');
        // return
        // window.open(
        //  `${process.env.REACT_APP_PAYMENT_URL}/#/payment-prev?billid=${billId}&https=true&domain=${process.env.REACT_APP_DEFAULT_API_URL}`,
        //  "_blank",
        //  "noreferrer"
        // );
        setFormData({
          ...formData,
          creditPoint: "",
          remarks: "",
        });
        setShowModal(false)

      } catch (error) {
        setIsLoader(false)
        console.error('error::: ', error);

      }finally{
        setIsLoader(false)
      }
    }



  };



  return (
    <>
    {/* {setIsLoader && <Spinner />} */}
    <div className="recharge_modal_container">
      <div className="modal-body">
        <form>
          <div className="form-group">
            <label>
              Wallet amount <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control"
              name="creditPoint"
              value={formData.creditPoint}
              onChange={handleInputChange}
              placeholder="Enter wallet amount"
            />
          </div>
          <div className="form-group">
            <label>Remarks</label>
            <textarea
              className="form-control"
              name="remarks"
              value={formData.remarks}
              onChange={handleInputChange}
              rows="3"
              placeholder="Enter remarks"
            ></textarea>
          </div>
        </form>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-warning"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
    </div>
    </>
  );
}
